export enum PaymentMethodsEnum  {
    card = 1,
    bank = 2,
    escrow = 3,
    check = 4,
  };
  